import { render } from "./UniqueSiteInformations.vue?vue&type=template&id=05421148&scoped=true"
import script from "./UniqueSiteInformations.vue?vue&type=script&lang=js"
export * from "./UniqueSiteInformations.vue?vue&type=script&lang=js"

import "./UniqueSiteInformations.vue?vue&type=style&index=0&id=05421148&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05421148"]])

export default __exports__